import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
// import { homeDomain } from '@utils/domainByEnv';
// import timeoutImg from '../imgs/timeout_gif.gif';
import { Loading } from '@lion-design/core';

const TimeOut = () => {
    const [hide, setHide] = useState(true);

    // const imghref = () => {
    //     switch (process.env.ENV) {
    //         case 'prod':
    //         case 'rel':
    //             return `https:${homeDomain}/_webassets/lightspeed/subsitebundles/common/imgs/timeout_gif.gif`;
    //         default:
    //             return timeoutImg;
    //     }
    // };

    useEffect(() => {
        let interval: any;

        if (hide) {
            interval = setInterval(() => {
                setHide(false);
            }, 1200000);
        } else {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [hide]);

    const handleReload = () => location.reload();

    const handleRedirect = () =>
        window.location.replace('https://www.liontravel.com/airlineticket/');

    return (
        <div className={cN(styles.loadingWrap, { [styles.hide]: hide })}>
            <div className={styles.loadingBox}>
                {/* <img className="" src={imghref()} alt="timeOut" height="192px" /> */}
                <Loading theme="timeout" width={90} bgColor="#e10500" visible={true} />
                <div className={styles.title}>閒置時間過長</div>
                <div className={styles.sub}>建議您重新整理，將為您提供最新的航班價格與機位</div>
                <div className={styles.buttons}>
                    <button onClick={handleReload}>原日期查詢航班</button>
                    <button onClick={handleRedirect}>選擇新日期查詢航班</button>
                </div>
            </div>
        </div>
    );
};

export default TimeOut;
